<template>
  <div>
    <CardBase>
      <template #header>{{ $route.meta.title }}</template>
      <template #content>
        <form
          class="form form-search"
          method="get"
          @submit.prevent="reloadDashboard"
        >
          <div class="form-search__row">
            <div class="form-search__double">
              <label class="form__label">Asset Group</label>
              <select
                class="form__input"
                v-model="formData.group_id"
                @change="setGroup"
              >
                <option value="" v-if="listGroup.length > 1" disabled>
                  Please Choose
                </option>
                <option value="" v-if="listGroupLoading">Please wait</option>
                <option v-for="row in listGroup" :key="row.id" :value="row.id">
                  {{ row.code_name }}
                </option>
              </select>
            </div>
            <div class="form-search__double">
              <label class="form__label">Asset</label>
              <multiselect
                v-model="formData.asset"
                :options="listAsset"
                :loading="listAssetLoading"
                :close-on-select="true"
                :hide-selected="false"
                track-by="id"
                label="name"
                :placeholder="
                  !formData.group_id
                    ? 'Please choose Asset Group'
                    : formData.asset
                    ? formData.asset.name
                    : 'All Asset'
                "
                :allow-empty="true"
                deselectLabel=""
                @input="
                  formData.asset_id = formData.asset ? formData.asset.id : ''
                "
              >
                <template #noResult>No results found.</template>
              </multiselect>
            </div>
          </div>
          <div class="form-search__row">
            <div class="form-search__double">
              <label class="form__label">Start Date</label>
              <date-picker
                v-model="formData.start_date"
                type="date"
                :editable="false"
                :clearable="false"
                input-class="form__input"
                value-type="YYYY-MM-DD"
                format="DD MMMM YYYY"
                placeholder="Start Date"
                @close="checkEndDate"
                :disabled-date="notAfterToday"
              ></date-picker>
            </div>
            <div class="form-search__double">
              <label class="form__label">End Date</label>
              <date-picker
                v-model="formData.end_date"
                type="date"
                :editable="false"
                :clearable="false"
                input-class="form__input"
                value-type="YYYY-MM-DD"
                format="DD MMMM YYYY"
                placeholder="End Date"
                :disabled-date="notBeforeStart"
              ></date-picker>
            </div>
          </div>

          <div class="form-search__action">
            <div class="w-3/12 flex">
              <BaseButton type="submit" class="mr-2" buttonClass="secondary"
                >Search</BaseButton
              >
              <BaseButton type="button" buttonClass="default" @click="reset"
                >Reset Search</BaseButton
              >
            </div>
          </div>
        </form>

        <div class="w-full ws:1/2" v-if="dashboardReady">
          <div class="flex flex-wrap md:flex-no-wrap my-4">
            <InfoCard
              :route="{
                name: 'NexusDepositList',
                query: {
                  search: '',
                  status: -1,
                  limit: 10,
                  asset_id: formData.asset_id,
                  start_date: formData.start_date,
                  end_date: formData.end_date,
                  sort_dir: 'desc',
                },
              }"
              class="w-full md:w-1/3 bg-red-500 text-white hover:bg-red-700"
              :icon="['fas', 'exclamation-triangle']"
              iconSize="4x"
              cardTitle="Missing Deposit"
              :cardTitleSub="deposit.pending.count || '0'"
              cardContentTitle="Amount"
              :cardContent="deposit.pending.amount"
            />
            <InfoCard
              :route="{
                name: 'WithdrawList',
                query: {
                  status: 2,
                  order: 'desc',
                  limit: 10,
                  asset_id: formData.asset_id,
                  start_date: formData.start_date,
                  end_date: formData.end_date,
                  sort_dir: 'desc',
                },
              }"
              class="md:mx-4 md:my-0 my-4 w-full md:w-1/3 bg-red-500 text-white hover:bg-red-700"
              :icon="['fas', 'exclamation-triangle']"
              iconSize="4x"
              cardTitle="Missing Withdrawal"
              :cardTitleSub="withdraw.pending.count || '0'"
              cardContentTitle="Amount"
              :cardContent="withdraw.pending.amount"
            />
          </div>

          <div class="flex flex-wrap md:flex-no-wrap my-4">
            <InfoCard
                :route="{
                name: 'NexusDepositList',
                query: {
                  search: '',
                  status: -1,
                  limit: 10,
                  asset_id: formData.asset_id,
                  start_date: formData.start_date,
                  end_date: formData.end_date,
                  sort_dir: 'desc',
                },
              }"
                class="w-full md:w-1/3 bg-blue-500 text-white hover:bg-blue-700"
                :icon="['fas', 'edit']"
                iconSize="4x"
                cardTitle="Action Required"
                :cardTitleSub="deposit.action.count || '0'"
                cardContentTitle="Amount"
                :cardContent="deposit.action.amount"
            />
            <InfoCard
                :route="{
                name: 'NexusWithdrawList',
                query: {
                  search: '',
                  status: -1,
                  limit: 10,
                  asset_id: formData.asset_id,
                  start_date: formData.start_date,
                  end_date: formData.end_date,
                  sort_dir: 'desc',
                },
              }"
                class="md:mx-4 md:my-0 my-4 w-full md:w-1/3 bg-blue-500 text-white hover:bg-blue-700"
                :icon="['fas', 'edit']"
                iconSize="4x"
                cardTitle="Action Required"
                :cardTitleSub="withdraw.action.count || '0'"
                cardContentTitle="Amount"
                :cardContent="withdraw.action.amount"
            />
          </div>

          <div class="flex flex-wrap md:flex-no-wrap">
            <InfoCard
              :route="{
                name: 'NexusDepositList',
                query: {
                  search: '',
                  status: 2,
                  limit: 10,
                  asset_id: formData.asset_id,
                  start_date: formData.start_date,
                  end_date: formData.end_date,
                  sort_dir: 'desc',
                },
              }"
              class="
                w-full
                md:w-1/3
                bg-yellow-500
                text-white
                hover:bg-yellow-700
              "
              :icon="['far', 'eye-slash']"
              iconSize="4x"
              cardTitle="Hidden Deposit"
              :cardTitleSub="deposit.hidden.count || '0'"
              cardContentTitle="Amount"
              :cardContent="deposit.hidden.amount"
            />
            <InfoCard
                :route="{
                name: 'WithdrawList',
                query: {
                  status: 2,
                  order: 'desc',
                  limit: 10,
                  asset_id: formData.asset_id,
                  start_date: formData.start_date,
                  end_date: formData.end_date,
                  sort_dir: 'desc',
                },
              }"
                class="md:mx-4 md:my-0 my-4 w-full md:w-1/3 bg-yellow-500 text-white hover:bg-yellow-700"
                :icon="['far', 'eye-slash']"
                iconSize="4x"
                cardTitle="Hidden Withdrawal"
                :cardTitleSub="withdraw.hidden.count || '0'"
                cardContentTitle="Amount"
                :cardContent="withdraw.hidden.amount"
            />
          </div>

          <div class="flex flex-wrap md:flex-no-wrap my-4">
            <InfoCard
              :route="{
                name: 'NexusDepositList',
                query: {
                  search: '',
                  status: 1,
                  limit: 10,
                  asset_id: formData.asset_id,
                  start_date: formData.start_date,
                  end_date: formData.end_date,
                  sort_dir: 'desc',
                },
              }"
              class="w-full md:w-1/3 bg-green-500 text-white hover:bg-green-700"
              :icon="['fas', 'check-circle']"
              iconSize="4x"
              cardTitle="Processed Deposit"
              :cardTitleSub="deposit.success.count || '0'"
              cardContentTitle="Amount"
              :cardContent="deposit.success.amount"
            />
            <InfoCard
                :route="{
                name: 'WithdrawList',
                query: {
                  status: 2,
                  order: 'desc',
                  limit: 10,
                  asset_id: formData.asset_id,
                  start_date: formData.start_date,
                  end_date: formData.end_date,
                  sort_dir: 'desc',
                },
              }"
                class="md:mx-4 md:my-0 my-4 w-full md:w-1/3 bg-green-500 text-white hover:bg-green-700"
                :icon="['far', 'eye-slash']"
                iconSize="4x"
                cardTitle="Processed Withdrawal"
                :cardTitleSub="withdraw.success.count || '0'"
                cardContentTitle="Amount"
                :cardContent="withdraw.success.amount"
            />
          </div>

          <div class="flex flex-wrap md:flex-no-wrap">
            <InfoCard
              class="w-full md:w-1/3 bg-gray-500 text-white"
              :icon="['fas', 'coins']"
              iconSize="4x"
              cardTitle="Total Deposit"
              :cardTitleSub="deposit.all.count || '0'"
              cardContentTitle="Amount"
              :cardContent="deposit.all.amount"
            />
            <InfoCard
                class="md:mx-4 md:my-0 my-4 w-full md:w-1/3 bg-gray-500 text-white"
                :icon="['fas', 'coins']"
                iconSize="4x"
                cardTitle="Total Withdraw"
                :cardTitleSub="withdraw.all.count || '0'"
                cardContentTitle="Amount"
                :cardContent="withdraw.all.amount"
            />
          </div>
        </div>
      </template>
    </CardBase>
  </div>
</template>

<script>
import InfoCard from "@/components/InfoCard";
import { datePickerMixin } from "@/mixins/datePickerMixin";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";

export default {
  data() {
    return {
      listAsset: [],
      listAssetLoading: false,
      listGroup: [],
      listGroupLoading: true,
      dashboardReady: false,
      formData: {
        type_id: "",
        asset: null,
        asset_id: "",
        start_date: null,
        end_date: null,
        group_id: "",
      },
      deposit: {
        all: {
          count: 0,
          amount: 0,
        },
        hidden: {
          count: 0,
          amount: 0,
        },
        pending: {
          count: 0,
          amount: 0,
        },
        success: {
          count: 0,
          amount: 0,
        },
        action: {
          count: 0,
          amount: 0,
        },
      },
      withdraw: {
        action: {
          count: 0,
          amount: 0,
        },
        all: {
          count: 0,
          amount: 0,
        },
        hidden: {
          count: 0,
          amount: 0,
        },
        pending: {
          count: 0,
          amount: 0,
        },
        success: {
          count: 0,
          amount: 0,
        },
      },
    };
  },
  mixins: [datePickerMixin],
  components: {
    DatePicker,
    InfoCard,
    Multiselect,
  },
  created() {
    this.formData.start_date = this.moment(new Date()).format("YYYY-MM-DD");
    this.formData.end_date = this.moment(new Date()).format("YYYY-MM-DD");
    this.getListGroup();
    this.loadDashboard();
  },
  watch: {
    $route() {
      const queryParams = this.$route.query;
      if (queryParams.asset_id != undefined) {
        this.formData = { ...this.formData, ...this.$route.query };
        this.listAsset.forEach((data) => {
          if (data.id == queryParams.asset_id) {
            this.formData.asset = data;
            this.formData.asset_id = data.id;
          }
        });
      }
    },
  },
  methods: {
    getListGroup() {
      this.listGroupLoading = true;
      this.$http
        .get(process.env.VUE_APP_API_URL + "/group?central=1")
        .then((res) => {
          if (res.status == 200) {
            const response = res.data;

            if (response) {
              this.listGroup = response.data;

              if (this.listGroup.length == 1) {
                this.getListAsset(this.listGroup[0].id);
                this.formData.group_id = this.listGroup[0].id;
              }
            }
          }
        })
        .finally(() => {
          this.listGroupLoading = false;
        });
    },
    setGroup() {
      this.formData.asset_id = "";
      this.formData.asset = null;
      this.getListAsset(this.formData.group_id);
    },
    getListAsset(groupId) {
      this.formData.asset = null;
      this.listAssetLoading = true;

      this.$http
        .get(process.env.VUE_APP_API_URL + "/asset/sync?group_id=" + groupId)
        .then((res) => {
          if (res.status == 200) {
            const response = res.data;

            if (response) {
              this.listAsset = response.data;
              const queryParams = this.$route.query;

              if (queryParams.asset_id != undefined) {
                this.listAsset.forEach((data) => {
                  if (data.id == queryParams.asset_id) {
                    this.formData.asset = data;
                  }
                });
              }
            }
          }
        })
        .finally(() => {
          this.listAssetLoading = false;
        });
    },
    reloadDashboard() {
      if (!this.formData.group_id) {
        this.$swal({
          position: "bottom-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
          title: "Please choose Asset Group",
          icon: "warning",
        });
      } else {
        this.$router.replace(
          {
            query: {
              group_id: this.formData.group_id,
              asset_id: this.formData.asset_id,
              start_date: this.formData.start_date,
              end_date: this.formData.end_date,
              type_id: this.formData.type_id,
              tz: new Date().getTime(),
            },
          },
          () => {
            this.loadDashboard();
          }
        );
      }
    },
    loadDashboard() {
      if (this.$route.query.group_id) {
        this.$store.commit("toggleLoading");

        this.formData = { ...this.formData, ...this.$route.query };

        this.getListAsset(this.formData.group_id)

        this.$http
          .get(
            process.env.VUE_APP_API_URL +
              "/nexus-transaction/summary?group_id=" +
              this.formData.group_id +
              "&type_id=" +
              this.formData.type_id +
              "&asset_id=" +
              this.formData.asset_id +
              "&start_date=" +
              this.formData.start_date +
              "&end_date=" +
              this.formData.end_date
          )
          .then((res) => {
            if (res.status == 200) {
              this.loading = false;
              this.dashboardReady = true;

              const response = res.data.data;

              if (response) {
                this.deposit = { ...this.deposit, ...response.deposit };
                this.withdraw = { ...this.withdraw, ...response.withdraw };
                this.transfer = { ...this.transfer, ...response.transfer };
              }
            }
          })
          .finally(() => {
            this.$store.commit("toggleLoading");
          });
      }
    },
    reset() {
      this.formData.asset = null;
      this.formData.asset_id = "";
      this.formData.group_id = "";
      this.formData.start_date = this.moment(new Date()).format("YYYY-MM-DD");
      this.formData.end_date = this.moment(new Date()).format("YYYY-MM-DD");
      this.dashboardReady = false;

      this.$router.push({ name: "NexusSyncReport" }).catch(() => {});
    },
  },
};
</script>